export class ParametroFiltro {
    public cdFazenda: number;
    public editavelWeb: boolean;
    public geral: boolean;
}
